

































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import Modal from '@/modules/common/dialog/components/shared/Modal'
import { MediaResourceModel } from '@/modules/media/models/media-resource.model'

@Component({
  components: { Modal }
})
export default class MediaAttachmentDialog extends Vue {
  @Prop() attachments: MediaResourceModel[] | null
  private attachmentsModal = false
}
